import React, { useRef } from "react";
import { formatDayLabel } from "../../utility/bulkSquadTree";

const SquadDateTrigger = ({ value, onChange, disabled }) => {
  const inputRef = useRef(null);

  const openPicker = () => {
    const input = inputRef.current;
    if (!input || disabled) return;
    try {
      if (typeof input.showPicker === "function") {
        input.showPicker();
      }
    } catch {
      input.focus();
    }
  };

  return (
    <div className="relative inline-flex min-w-[9.5rem] h-10">
      <button
        type="button"
        disabled={disabled}
        onClick={openPicker}
        className={`flex w-full items-center h-10 px-3 rounded-lg border text-sm font-medium ${
          value
            ? "border-brand-charcoal/15 bg-white text-brand-charcoal"
            : "border-dashed border-brand-charcoal/30 text-brand-muted"
        }`}
      >
        {formatDayLabel(value)}
      </button>
      <input
        ref={inputRef}
        type="date"
        value={value || ""}
        onChange={(event) => onChange(event.target.value)}
        onClick={openPicker}
        disabled={disabled}
        aria-label="Squad date"
        className="absolute inset-0 z-10 w-full h-full cursor-pointer appearance-none bg-transparent text-transparent [&::-webkit-datetime-edit]:text-transparent [&::-webkit-calendar-picker-indicator]:absolute [&::-webkit-calendar-picker-indicator]:inset-0 [&::-webkit-calendar-picker-indicator]:h-full [&::-webkit-calendar-picker-indicator]:w-full [&::-webkit-calendar-picker-indicator]:cursor-pointer [&::-webkit-calendar-picker-indicator]:opacity-0"
      />
    </div>
  );
};

export default SquadDateTrigger;
